




import { Component, Vue, Prop } from 'vue-property-decorator'
import * as modules from '../../../store/decorator'

@Component
export default class VUploadId extends Vue {

    @Prop(String) label!: string
    @Prop(Array) errorMessages!: Array <object>

    value: string = ''

    mounted() {

        this.$http.put(process.env.VUE_APP_V3_CCTV_UPLOAD_ID, {
            code: modules.user.customerDetail.code,
            email: modules.user.userDetail.email
        }, 
        {
            headers: {
                Authorization: process.env.VUE_APP_V3_API_KEY
            }
        }).then(response => {

            this.$emit('change', response.data.id)
            this.$emit('extra', response.data)
            this.value = response.data.id
        })
    }
}
